export default __webpack_public_path__ + "static/media/work4.86a49372.jpg";